import { FC, useEffect, useState } from 'react'
import { Box } from '@mui/material'
import { TCloudinaryImageData } from 'fractals'
import Image from 'next/image'

type Props = {
  number: number
  title: string
  image: TCloudinaryImageData<'least'>
}

const Card: FC<Props> = ({ number, title, image }) => {
  const [imageSize, setImageSize] = useState<number>(170)

  useEffect(() => {
    const getImageSize = () => {
      if (matchMedia('(max-width: 375px)').matches) {
        return 130
      }

      if (matchMedia('(max-width: 768px)').matches) {
        return 154
      }

      return 170
    }

    const handleResize = () => {
      setImageSize(getImageSize())
    }

    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  return (
    <Box
      bgcolor='var(--alpha)'
      display='grid'
      gridTemplateAreas={`
        "number image"
        "title  title"
      `}
      borderRadius='16px'
      p='24px'
      overflow='hidden'
      sx={{
        '@media (min-width: 1281px)': {
          aspectRatio: '1 / 1'
        }
      }}>
      <span
        style={{
          gridArea: 'number',
          lineHeight: '120%'
        }}>
        {`0${number}.`}
      </span>
      <Image
        src={image.url ?? ''}
        width={imageSize}
        height={imageSize}
        alt={image.alternativeText ?? ''}
        style={{
          gridArea: 'image',
          justifySelf: 'end',
          marginTop: '-24px',
          marginRight: '-24px'
        }}
      />
      <span
        style={{
          gridArea: 'title',
          lineHeight: '120%',
          alignSelf: 'end'
        }}>
        {title}
      </span>
    </Box>
  )
}

export default Card
